import { switchCoach } from 'api/coach';
import { useMutation } from '@tanstack/react-query';

export const useSwitchCoachMutation = () => {
  return useMutation((payload: { coachId: string }) => switchCoach(payload.coachId));
};
